/**
 * "Put the cursor in the search box", from anywhere: ⌘K / Ctrl+K, and the
 * search button in the phone's top bar.
 *
 * The box lives on the library screen, which may not be mounted yet when the
 * shortcut fires (it navigates there first). So the request is both a flag the
 * screen reads when it mounts and an event it hears if it already is. Whichever
 * happens first clears the flag.
 */

const EVENT = "iltocat:focus-search";
let pending = false;

export function requestSearchFocus(): void {
  pending = true;
  window.dispatchEvent(new Event(EVENT));
}

/** Call from the screen that owns the box. Returns the unsubscribe. */
export function onSearchFocus(focus: () => void): () => void {
  const run = () => {
    if (!pending) return;
    pending = false;
    focus();
  };
  run();
  window.addEventListener(EVENT, run);
  return () => window.removeEventListener(EVENT, run);
}
